module.exports = __webpack_public_path__ + "static/media/icon-chevron-blue.58b9571b.svg";